import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { SIDENAV_WIDTH, SIDENAV_MINI_WIDTH, SIDENAV_GAP } from "./constants";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { isDesktop, isMini, transparentSidenav, whiteSidenav, darkMode, direction } = ownerState;
  const { palette, functions, transitions, boxShadows } = theme;
  const transparent = isDesktop && transparentSidenav;
  const white = isDesktop && whiteSidenav;
  const background = transparent
    ? palette.transparent.main
    : white
    ? palette.white.main
    : darkMode
    ? palette.background.sidenav
    : functions.linearGradient(palette.gradients.dark.main, palette.gradients.dark.state);
  const width = isMini ? SIDENAV_MINI_WIDTH : SIDENAV_WIDTH;
  return {
    ...(isDesktop ? { width, flexShrink: 0 } : {}),
    "& .MuiDrawer-paper": {
      width: isDesktop ? width : `min(${SIDENAV_WIDTH}px, calc(100vw - 32px))`,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      height: isDesktop ? `calc(100dvh - ${SIDENAV_GAP * 2}px)` : "100dvh",
      margin: isDesktop ? SIDENAV_GAP : 0,
      border: "none",
      borderRadius: isDesktop ? "16px" : direction === "rtl" ? "16px 0 0 16px" : "0 16px 16px 0",
      overflow: "hidden",
      background,
      boxShadow: transparent ? "none" : boxShadows.xxl,
      transition: transitions.create(["width", "background-color"], {
        duration: transitions.duration.standard,
      }),
    },
  };
});
